import { Box, styled } from "@mui/material";

export const Description = styled(Box)`
  max-height: 25vh;
  overflow: auto;
  display: block;
`;
